import { useEffect, useState } from "react"
import { BookOpen, Monitor } from "lucide-react"
import { formatRelativeTime } from "./helpers"

const API_BASE = import.meta.env.VITE_API_BASE_URL || "http://127.0.0.1:8787"

// Pre-rendered demo display SVG — editorial "during stay" layout
// Villa Seaview, The Müller Family, Night 3 of 5, 24° Clear evening, sunset 21:08
// Message demonstrates: stay-stage awareness, weather-shaped prose, specific local knowledge, literary tone
const DEMO_DISPLAY_SVG = "data:image/svg+xml;base64,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"

interface OverviewDisplayPreviewProps {
  propertyId: string
  title: string
  summary: string
  detail?: string | null
  generatedAt?: string | null
  facts?: string[]
  isDemo?: boolean
}

export function OverviewDisplayPreview({
  propertyId,
  title,
  summary,
  detail,
  generatedAt,
  facts = [],
  isDemo,
}: OverviewDisplayPreviewProps) {
  const [imgStatus, setImgStatus] = useState<"loading" | "loaded" | "error">(isDemo ? "loaded" : "loading")
  const displayUrl = isDemo
    ? DEMO_DISPLAY_SVG
    : `${API_BASE}/display/preview.svg?property_id=${encodeURIComponent(propertyId)}`

  useEffect(() => {
    if (!isDemo) setImgStatus("loading")
  }, [displayUrl, isDemo])

  return (
    <aside className="ovx-preview">
      <div className="ovx-preview__header">
        <div>
          <span className="ovx-preview__eyebrow">Guest-facing now</span>
          <h2 className="ovx-preview__title">{title}</h2>
        </div>
        <span className="ovx-preview__meta">Preview only</span>
      </div>

      <div className="ovx-preview__frame">
        {imgStatus === "error" ? (
          <div className="ovx-preview__empty">
            <Monitor className="h-5 w-5" />
            <span>Live preview unavailable</span>
          </div>
        ) : (
          <img
            src={displayUrl}
            alt="Stayframe display preview"
            className="ovx-preview__image"
            onLoad={() => setImgStatus("loaded")}
            onError={() => setImgStatus("error")}
            style={{ opacity: imgStatus === "loaded" ? 1 : 0 }}
          />
        )}
      </div>

      <div className="ovx-preview__body">
        <p className="ovx-preview__summary">{summary}</p>
        {detail && <p className="ovx-preview__detail">{detail}</p>}

        <div className="ovx-preview__facts">
          {generatedAt && (
            <span className="ovx-preview__fact">
              <Monitor className="h-3.5 w-3.5" />
              Updated {formatRelativeTime(generatedAt)}
            </span>
          )}
          {facts.map((fact) => (
            <span key={fact} className="ovx-preview__fact">
              <BookOpen className="h-3.5 w-3.5" />
              {fact}
            </span>
          ))}
        </div>
      </div>
    </aside>
  )
}
